<template>
  <nav
    :class="[
      'd-nav',
      `d-nav--${dashboardTransitionState}`,
    ]"
  >
    <div class="d-nav__wrapper">
      <div class="d-nav__panels">
        <div
          v-if="userIsRole(panel.role)"

          v-for="(panel, index) in panels"
          :key="index"

          class="d-nav__panel"
        >
          <p class="h6 d-nav__heading" v-html="panel.title"/>
          <ul class="d-nav__list">
            <li
              v-for="(link, index) in panel.links"
              :key="index"
              class="p"
            >
              <module-link :link="link.link" class="d-nav__link">{{ link.title }}</module-link>
            </li>
          </ul>
        </div>
      </div>
      <span class="p d-nav__logout">
        <module-link
          class="dashboard__link"

          link="logout"
          label="Log out"
          icon="logout"
          :icon-negative="true"
          :no-underline="true"
        />
      </span>
    </div>
  </nav>
</template>

<script>
// Vuex
import { mapGetters } from 'vuex';

// Models
import dashboardPanels from 'models/dashboard/navigation';

// UI
import UiTooltip from 'ui/Tooltip';

// Modules
import ModuleIcon from 'modules/Icon';
import ModuleLink from 'modules/Link';

// Export
export default {
  name: `ui-dashboard-navigation`,

  // Components
  components: {
    ModuleIcon,
    ModuleLink,
    UiTooltip,
  },
  // Data
  data() {
    return {
      panels: dashboardPanels,
    };
  },
  computed: {
    ...mapGetters(`auth`, [
      `user`,
      `userRole`,
      `userIsRole`,
    ]),
    ...mapGetters(`dashboard`, [
      `dashboardTransitionState`,
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// Navigation.vue?2f0d7d5a